import { useQuery } from "@tanstack/react-query";
import { getAccessibleAgList, getDropdownValues } from "../QuoteService";
import {
  getAllAg,
  getAllCustomer,
  getAllProduct,
  getProductAttributes,
} from "../../Orders/OrderService";

// AG dropdown options for the quote Details tab.
export const useQuoteAgOptions = (ownerId, enabled = true) =>
  useQuery({
    queryKey: ["quote", "ag-options", ownerId],
    queryFn: () => getAllAg(ownerId),
    enabled: enabled && Boolean(ownerId),
  });

// Product dropdown options, available once AG and Product Type are chosen.
export const useQuoteProductOptions = (agId, productType, enabled = true) =>
  useQuery({
    queryKey: ["quote", "product-options", agId, productType],
    queryFn: () => getAllProduct(agId, productType),
    enabled: enabled && Boolean(agId) && Boolean(productType),
  });

// Members of the selected AG, used as recipients in the Send Quote modal.
export const useQuoteMemberOptions = (agId, enabled = true) =>
  useQuery({
    queryKey: ["quote", "member-options", agId],
    queryFn: () => getAllCustomer("AGRP", agId),
    enabled: enabled && Boolean(agId),
  });

// Child products and their attributes for a product (stored by the service);
// returns the id so the query has defined data.
export const useProductAttributes = (productId, enabled = true) =>
  useQuery({
    queryKey: ["quote", "product-attributes", productId],
    queryFn: async () => {
      await getProductAttributes(productId);
      return productId;
    },
    enabled: enabled && Boolean(productId),
  });

// Distinct column values for a dropdown (State, City of AG members)
export const useDropdownValues = (entityType, columnName, enabled = true) =>
  useQuery({
    queryKey: ["dropdown-values", entityType, columnName],
    queryFn: () => getDropdownValues(entityType, columnName),
    enabled,
  });

// Full AG entities, used to map an AG to its organization id
export const useQuoteAgList = (ownerId, enabled = true) =>
  useQuery({
    queryKey: ["quote", "ag-list", ownerId],
    queryFn: () => getAccessibleAgList(ownerId),
    enabled: enabled && Boolean(ownerId),
  });
